import { analyticsId, trackProduct } from './productAnalytics';

// No health input/record IDs/URLs. A resumed device-local draft retains its opaque flow ID.
let registration = null;
let entry = null;
export function journey(feature, stage, source = 'web', sessionId = null, regimen = null) {
    try { trackProduct(`journey_${stage}`, { feature, source, ...(sessionId ? { sessionId } : {}),
        ...(['scheduled', 'as_needed'].includes(regimen) ? { regimen } : {}) }); } catch {}
}
export function createRegistrationJourney(source = 'manual', previousId = null, regimen = null) {
    let id = typeof previousId === 'string' && /^[a-zA-Z0-9_-]{8,100}$/.test(previousId) ? previousId : null;
    if (!id) {
    try { id = analyticsId(); } catch { id = `flow_${Date.now().toString(36)}_${Math.random().toString(36).slice(2)}`; }
    }
    const context = { id, source, regimen };
    return {
        get id() { return context.id; },
        get source() { return context.source; },
        mount() { registration = context; if (!previousId) journey('registration', 'start', context.source, context.id, context.regimen); else journey('registration_draft', 'select', context.source, context.id, context.regimen); },
        unmount() { if (registration === context) registration = null; },
        photo() { context.source = 'photo'; },
        event(stage, feature = 'registration') { journey(feature, stage, context.source, context.id, context.regimen); },
    };
}
export function registrationEvent(feature, stage) {
    if (registration) journey(feature, stage, registration.source, registration.id, registration.regimen);
}
export function observeEntry(source) {
    if (!['widget', 'notification'].includes(source)) return;
    entry = { source, at: Date.now() };
    journey(source, 'complete', source);
}
export function journeyHeaders(url) {
    try {
        if (registration && /\/devices\/[^/]+\/(medications(?:\/bulk|\/slot-reward-bonus)?|medication-bundles\/analyze-(?:image|names)|suggest)$/.test(url || '')) {
            return { 'X-Product-Journey-Id': registration.id, 'X-Product-Journey-Source': registration.source };
        }
        if (/\/logs(?:\/\d+)?\/confirm$/.test(url || '')) {
            const source = entry && Date.now() - entry.at < 30 * 60 * 1000 ? entry.source : 'web';
            return { 'X-Product-Journey-Source': source };
        }
    } catch {}
    return {};
}
export function clearJourneyIdentity() { registration = null; entry = null; }
export const pageJourneys = {
    '/calendar': 'calendar', '/stats': 'stats', '/guardian': 'family_status', '/my-guardians': 'family_status',
    '/family-care': 'family_invite', '/onboarding': 'onboarding', '/chat': 'ai_reply', '/symptoms': 'symptom_save',
    '/prn': 'prn_record', '/medications': 'medication_edit', '/settings': 'notification_settings',
};
